// ============================================================================
// page-projects / hero.js
// ----------------------------------------------------------------------------
// Hero "SCROLL" button: smooth-scrolls down to the projects filter/list
// section.
//
// The original inline JS targeted `#projects` as an id, but no element in the
// Oxygen tree has that id set in the JSON. The `.projects` class on the
// section is reliable, so we fall back to it. This way the button still
// works whether or not someone later sets html_id="projects" in Oxygen.
// ============================================================================

document.addEventListener("DOMContentLoaded", function () {
  const scrollButton = document.querySelector(".service-hero__scroll");
  const target =
    document.querySelector("#projects") || document.querySelector(".projects");

  if (!scrollButton || !target) return;

  scrollButton.addEventListener("click", function () {
    target.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  });
});
